module.exports = __webpack_public_path__ + "static/section-bg-5ce384d93e27a90f016d9aaff1ed9027.png";